export default "__VITE_ASSET__CMyibylc__"